/**
 * Example Schema to use AutoComplete
 *
 * const suggestions = [
  { name: "JavaScript", displayId: 1 },
  { name: "React", displayId: 2 },
  { name: "Node.js", displayId: 3 },
  { name: "Python", displayId: 4 },
  { name: "Angular", displayId: 5 },
];
<AutoComplete
  suggestions={suggestions}
  autoCompletePlaceHolders="Search for a language"
  onValueSelect={(selectedValues) =>
    console.log("Selected Values: ", selectedValues)
  }
  addedValuesHeading="Selected Languages"
  defaultValue={[
    { name: "React", displayId: 2 },
    { name: "Node.js", displayId: 3 },
  ]}
  renderAddedValues={true}
/>;
 *
 */

import React, { useEffect, useState } from "react";
import "./AutoComplete.scss";

const AutoComplete = ({
  label = "Search",
  suggestions, // array of objects
  autoCompletePlaceHolders = "Type anything to search",
  onValueSelect = () => {}, // callback function
  addedValuesHeading = "YOUR LANGUAGES",
  defaultValue,
  renderAddedValues = false,
  name,
  emptySearchField,
  errorCallback, // use it when you need to render your own error msg
  noErrorInAutoComplate = false,
  isEdit,
  resetValue,
  disabled = false, // disbale field
  onValueChangeCallback = () => {},
  onSelectedValueCallback = () => {},
  APIError,
  validationErrorText = "",
}) => {
  const [isInputFocused, setIsInputFocused] = useState(false);
  const [hasFocusedAtleastOneTime, setHasFocusedAtleastOneTime] =
    useState(false);
  const [
    hasKeyboardInputDownAtleastOneTime,
    setHasKeyboardInputDownAtleastOneTime,
  ] = useState(false);

  const [query, setQuery] = useState("");
  const [filteredSuggestions, setFilderedSuggestions] = useState([]);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);
  const [selectedValues, setSelectedValues] = useState(
    defaultValue?.length > 0 ? defaultValue : []
  );
  const [errorMessage, setErrorMessage] = useState("");
  const [deleteItem, setDeleteItem] = useState("");
  const [pingCount, setPingCount] = useState(0);
  const [isSelected, setIsSelected] = useState(false);

  useEffect(() => {
    if (resetValue) {
      setQuery("");
    }
  }, [resetValue]);

  useEffect(() => {
    return () => {
      setSelectedValues([]);
    };
  }, []);

  useEffect(() => {
    if (!defaultValue) {
      setQuery("");
    }
    if (defaultValue) {
      if (typeof defaultValue === "string") {
        setQuery(defaultValue);
      }
      setSelectedValues(defaultValue);
    }
  }, [defaultValue]);

  useEffect(() => {
    if (emptySearchField) {
      setQuery("");
    }
  }, [emptySearchField]);

  useEffect(() => {
    if (defaultValue) {
      if (typeof defaultValue !== "string") {
        setSelectedValues(defaultValue);
      }
    }
  }, []);

  useEffect(() => {
    onValueSelect(name, selectedValues);
    if (renderAddedValues) {
      setQuery("");
    }
  }, [selectedValues]);

  useEffect(() => {
    setSelectedValues((prev) =>
      (Array.isArray(prev) ? prev : []).filter((val) => val !== deleteItem)
    );
  }, [deleteItem]);

  useEffect(() => {
    setTimeout(() => {
      setErrorMessage("");
    }, 2000);
    setQuery("");
  }, [errorMessage]);

  useEffect(() => {
    if (isSelected) {
      return;
    }
    if (query?.trim()) {
      const normalizedQuery = query.toLowerCase();
      const filtered = suggestions?.filter((item) =>
        (item?.name || "").toLowerCase().includes(normalizedQuery)
      );
      setFilderedSuggestions(filtered);
      setIsDropdownVisible(filtered?.length > 0);
    } else {
      setFilderedSuggestions([]);
      setIsDropdownVisible(false);
    }
  }, [suggestions, query, isSelected]);

  const handleFocus = () => {
    setIsInputFocused(true);
    setHasFocusedAtleastOneTime(true);
  };

  const handleBlur = () => {
    setIsInputFocused(false);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    setIsSelected(false);
    if (pingCount < 1) {
      setPingCount(pingCount + 1);
    }
    onValueChangeCallback(value);
  };

  const handleKeyDown = (e) => {
    if (
      e.key === "ArrowDown" &&
      activeIndex < filteredSuggestions?.length - 1
    ) {
      setActiveIndex((prevIndex) => prevIndex + 1);
    } else if (e.key === "ArrowUp" && activeIndex > 0) {
      setActiveIndex((prevIndex) => prevIndex - 1);
    } else if (e.key === "Enter" && activeIndex >= 0) {
      handleSuggestionClick(filteredSuggestions[activeIndex]);
    } else if (e.key === "Escape") {
      setIsDropdownVisible(false);
    }
    if (e.keyCode >= 40 && e.keyCode <= 90) {
      setHasKeyboardInputDownAtleastOneTime(true);
    }
  };

  const handleSelectedValues = (suggestion) => {
    if (isEdit) {
      // console.log("isEdit", isEdit);
    } else {
      if (!selectedValues?.some((item) => item.name === suggestion.name)) {
        setSelectedValues((prevValue) => [...prevValue, suggestion]);
      } else {
        if (noErrorInAutoComplate) {
          errorCallback(suggestion.name);
        } else {
          setErrorMessage(`${suggestion.name} is already added`);
        }
      }
    }
    onSelectedValueCallback(suggestion);
  };

  // const selectSuggestion = (suggestion) => {
  //   setQuery(suggestion.name);
  //   setFilderedSuggestions([]);
  //   setIsDropdownVisible(false);
  //   setActiveIndex(-1);
  // };

  const handleSuggestionClick = (suggestion) => {
    setQuery(suggestion?.name || "");
    setIsSelected(true);
    setIsDropdownVisible(false);
    setFilderedSuggestions([]);
    setActiveIndex(-1);
    handleSelectedValues(suggestion);
  };

  // Render functions
  const RenderAddedValues = () => {
    if (!renderAddedValues) return null;
    if (selectedValues?.length < 0) return null;

    return (
      <div className="addedLanguagesWrapper">
        <div> {addedValuesHeading} </div>
        <hr />
        {selectedValues.map((langItem, index) => {
          return (
            <div className="langItemWrapper" key={index}>
              <button
                className="delete-icon"
                onClick={(e) => {
                  e.preventDefault();
                  setDeleteItem(langItem);
                }}
              >
                <i className="glyphicon glyphicon-minus"></i>
              </button>
              <div className="langItem"> {langItem.name}</div>
              <hr />
            </div>
          );
        })}
      </div>
    );
  };

  const RenderAutoComplete = () => {
    return (
      <div className={`autoCompleteWrapper`}>
        {errorMessage && (
          <div className="alert alert-danger" role="alert">
            {errorMessage}
          </div>
        )}
        {label && <label className="form-label">{label}</label>}
        <input
          className={`autoCompleteInput ${
            hasFocusedAtleastOneTime && validationErrorText && !query
              ? "error"
              : ""
          }`}
          disabled={disabled}
          type="text"
          name={name}
          value={query}
          // onChange={(e) => {
          //   setTimeout(() => {
          //     handleInputChange(e);
          //   }, 100);
          // }}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          onFocus={handleFocus}
          onBlur={handleBlur}
          placeholder={autoCompletePlaceHolders && autoCompletePlaceHolders}
        />
        {hasKeyboardInputDownAtleastOneTime && validationErrorText && !query ? (
          <p className="validationErrorText">{validationErrorText}</p>
        ) : null}
        {APIError && (
          <div className="alert alert-danger" role="alert">
            {APIError}
          </div>
        )}
        {isInputFocused && isDropdownVisible && filteredSuggestions?.length > 0 && (
          <ul className="autoCompleteDropdownList">
            {filteredSuggestions.map((suggestionItem, index) => {
              return (
                <div
                  key={suggestionItem.displayId}
                  onMouseDown={(e) => {
                    e.preventDefault();
                    handleSuggestionClick(suggestionItem);
                  }}
                  onMouseEnter={() => setActiveIndex(index)}
                  className={`${
                    index === activeIndex ? "active" : "inactive"
                  } `}
                  style={{
                    padding: "8px",
                    cursor: "pointer",
                    color: index === activeIndex ? "white" : "black",
                    backgroundColor:
                      index === activeIndex ? "#0077b7" : "white",
                  }}
                >
                  {suggestionItem.name}
                </div>
              );
            })}
          </ul>
        )}
      </div>
    );
  };

  return (
    <>
      {RenderAutoComplete()}
      {RenderAddedValues()}
    </>
  );
};

export default AutoComplete;
